import React from "react";
import { FOOTER_LINKS, HEADER_LINKS } from "../../constants";
import ScrollToTop from "../../components/ScrollToTop";
import { TitleTag } from "../../components/TitleTag";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import breadcrumbImage from "../../images/service/training.webp";
import Gallery from "../../components/Gallery";
import About from "../../components/About";

export const AboutPage = () => {
  return (
    <>
      <ScrollToTop />
      <TitleTag pageTitle="Home" />
      <Header dropDownLinks={HEADER_LINKS} />{" "}
      <BreadCrumb
        title="About Us"
        text="Lets tell you more"
        bgImage={breadcrumbImage}
      />
      <About />
      <Gallery />
      <Footer footerLinks={FOOTER_LINKS} />
    </>
  );
};
